'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var qwest = _interopRequireWildcard(require("qwest"));
var _Front = _interopRequireDefault(require("Layouts/Front"));
var _getErrorsFromResponse = _interopRequireDefault(require("Components/Forms/Functions/getErrorsFromResponse"));
var _CvForm = _interopRequireDefault(require("Components/Forms/Models/Cv/CvForm"));
var _loader = _interopRequireDefault(require("Pure/loader"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
class CandidateCvPage extends _react.Component {
  state = {
    loading: false
  };
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    component.fetchCv();
  }
  fetchCv = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post('/cv/get-mine').then(function (xhr, response) {
      component.setState({
        loading: false,
        cv: response.cv,
        account_status: response.account_status,
        error: undefined
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)(response),
        account_status: response.account_status
      });
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    return /*#__PURE__*/_react.default.createElement(_Front.default, _extends({
      page_title: "Mon CV | AspieJob"
    }, props), state.cv || state.account_status === 'accepted' ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("h1", {
      className: "c-title c-title--center "
    }, state.cv ? 'Mon CV' : 'Créer mon CV'), /*#__PURE__*/_react.default.createElement("div", {
      className: "o-content o-content--account"
    }, /*#__PURE__*/_react.default.createElement(_CvForm.default, {
      type: state.cv ? 'update' : 'create'
    }))) : state.error ? /*#__PURE__*/_react.default.createElement("div", {
      className: "o-content o-content--account u-margin-top-30"
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "u-full-width u-text-center"
    }, "Vous aurez acc\xE8s \xE0 nos services apr\xE8s votre premier rendez-vous. Nous vous contacterons prochainement. Si besoin, contactez-nous sur \xAB contact@aspiejob.org \xBB")) : /*#__PURE__*/_react.default.createElement("div", {
      className: "u-full-width u-positioned",
      style: {
        height: 200
      }
    }, /*#__PURE__*/_react.default.createElement(_loader.default, {
      bemit: ['bg-white', 'primary']
    })));
  }
}
exports.default = CandidateCvPage;
